<empathy-viewer-card [fullSize]="true" [noTitle]="true">
  <div slot="content">
    <div #carouselSwipeContainer class="carousel-view__container" [class.is-phone]="isPhone$ | async">
      <div class="carousel-view__container__actions">
        <button [title]="'system.carousel.moveToPreviousCard' | translate" class="prev-btn" [disabled]="activeCard$() === 0" (click)="onPrev()">
          <fa-icon [icon]="faChevronLeft"></fa-icon>
        </button>

        <empathy-viewer-progress-bar [color]="'primary'" [progress]="activeCard$() | progress: visibleCards$().length"></empathy-viewer-progress-bar>

        @if (activeCard$() < visibleCards$().length - 1) {
          <button
            [title]="'system.carousel.moveToNextCard' | translate"
            class="next-btn"
            [disabled]="!questionsGrp().get(visibleCards$()[activeCard$()].id).value"
            (click)="onNext()"
          >
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </button>
        }
      </div>

      <div class="carousel-view__container__question" scrollToTop [trigger]="!questionsGrp().get(visibleCards$()[activeCard$()].id)?.value">
        <div [id]="visibleCards$()[activeCard$()].id" class="carousel-view__container__question__title fs__xxxl fw__500">
          @if (!!visibleCards$()[activeCard$()].stimulus?.mediaId) {
            <empathy-option-media
              [media]="visibleCards$()[activeCard$()].stimulus"
              [altText]="visibleCards$()[activeCard$()].text"
              [align]="'center'"
              [noBorder]="true"
            >
              <span class="fs__xxxl fw__500" [innerHTML]="visibleCards$()[activeCard$()].text | translate"></span>
            </empathy-option-media>
          } @else {
            <span class="fs__xxxl fw__500" [innerHTML]="visibleCards$()[activeCard$()].text | translate"></span>
          }
        </div>

        @if (activeCard$() < visibleCards$().length - 1) {
          @for (cardQuestion of questionsGrp().value | keyvalue; track cardQuestion.key) {
            @if (cardQuestion.key === visibleCards$()[activeCard$()].id) {
              <mat-radio-group
                color="primary"
                class="carousel-view__container__question__choices"
                [@trigState]="activeCard$()"
                [disabled]="movingToNextCard$()"
                [attr.aria-labelledby]="cardQuestion.key"
                (change)="onMoveToNextCard(cardQuestion.key, $event)"
              >
                @for (option of visibleOptions$(); track activeCard$(); let first = $first) {
                  @if (question().useOtherInd && question().useOtherPosition === $index) {
                    <ng-container *ngTemplateOutlet="other"></ng-container>
                    <ng-container *ngTemplateOutlet="otherText"></ng-container>
                  }

                  @if (!!option.stimulus?.mediaId) {
                    <empathy-option-media
                      [media]="option.stimulus"
                      [altText]="option.text"
                      (clicked)="onMoveToNextCard(cardQuestion.key, { value: option.value })"
                    >
                      <ng-container [ngTemplateOutlet]="radiobutton"></ng-container>
                    </empathy-option-media>
                  } @else {
                    <div
                      class="carousel-view__container__question__choices__radiobutton"
                      [class.use-media]="useMedia$()"
                      (click)="onMoveToNextCard(cardQuestion.key, { value: option.value })"
                    >
                      <ng-container [ngTemplateOutlet]="radiobutton"></ng-container>
                    </div>
                  }

                  <ng-template #radiobutton>
                    <mat-radio-button
                      color="accent"
                      surveyAutoFocus
                      [disableRipple]="true"
                      [value]="option.value"
                      [checked]="option.value === questionsGrp().get(cardQuestion.key).get('value').value"
                      [animationDelay]="300"
                      [condition]="
                        questionsGrp().get(cardQuestion.key).get('value').value === option.value && cardQuestion.key === visibleCards$()[activeCard$()].id
                      "
                    >
                      <div class="survey-viewer__html-content fs__md" [innerHTML]="option.text"></div>
                    </mat-radio-button>
                  </ng-template>

                  @if (
                    question().useOtherInd &&
                    (question().useOtherPosition === null ||
                      question().useOtherPosition === undefined ||
                      question().useOtherPosition >= visibleOptions$().length) &&
                    $last
                  ) {
                    <ng-container *ngTemplateOutlet="other"></ng-container>
                    <ng-container *ngTemplateOutlet="otherText"></ng-container>
                  }
                }

                <ng-template #other>
                  <div
                    class="carousel-view__container__question__choices__radiobutton"
                    [class.use-media]="useMedia$()"
                    (click)="onMoveToNextCard(cardQuestion.key, otherOption)"
                  >
                    <mat-radio-button
                      color="accent"
                      [disableRipple]="true"
                      [checked]="otherOption.value === questionsGrp().get(cardQuestion.key).get('value').value"
                      [value]="otherOption.value"
                    >
                      <span class="survey-viewer__html-content fs__md">{{ otherOption.text | translate }}</span>
                    </mat-radio-button>
                  </div>
                </ng-template>
              </mat-radio-group>

              <ng-template #otherText>
                @if (questionsGrp().get(cardQuestion.key).get('value').value === otherOption.value) {
                  <div class="question-form__input">
                    <span class="label survey-viewer__html-content fs__md fw__400" [innerHTML]="question().otherLabel"></span>
                    <mat-form-field appearance="outline" class="eiq-survey-textarea">
                      <textarea
                        matInput
                        surveyAutoFocus
                        [formControl]="questionsGrp().get(cardQuestion.key).get('otherText') | toFormControl"
                        [required]="questionsGrp().get(cardQuestion.key).get('value').value === otherOption.value"
                        autocomplete="off"
                      ></textarea>
                    </mat-form-field>
                  </div>
                }
              </ng-template>
            }
          }
        }
      </div>
    </div>
  </div>
</empathy-viewer-card>
